var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "margin-right": "30px" } },
    [
      _c("a-button", { attrs: { disabled: "" } }, [
        _vm._v(_vm._s(_vm.currentKey)),
      ]),
      _vm.currentKey === "草稿" && _vm.submit
        ? _c(
            "a-button",
            {
              attrs: { disabled: _vm.canOperate, type: "primary" },
              on: { click: _vm.saveAndSubmit },
            },
            [_vm._v("保存并审批 ")]
          )
        : _vm._e(),
      _vm.confirm && !_vm.needSave
        ? _c(
            "a-button",
            {
              attrs: { disabled: _vm.canOperate, type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.showPanelVisible(false)
                },
              },
            },
            [_vm._v("提交审批 ")]
          )
        : _vm._e(),
      _vm.confirm && _vm.needSave
        ? _c(
            "a-button",
            {
              attrs: { disabled: _vm.canOperate, type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.showPanelVisible(false)
                },
              },
            },
            [_vm._v("保存并审批 ")]
          )
        : _vm._e(),
      _vm.currentKey !== "草稿" && _vm.currentKey !== "完成" && _vm.info.draft
        ? _c(
            "a-button",
            {
              attrs: { disabled: _vm.canOperate, type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.showPanelVisible(true)
                },
              },
            },
            [_vm._v("驳回到草稿 ")]
          )
        : _vm._e(),
      _vm.info.history
        ? _c(
            "a-button",
            {
              attrs: { disabled: _vm.canOperate, type: "primary" },
              on: { click: _vm.showHisPanel },
            },
            [_vm._v("查看审批记录 ")]
          )
        : _vm._e(),
      _c(
        "a-modal",
        {
          attrs: {
            title: "审批意见",
            centered: "",
            visible: _vm.showAuditAndSave,
            width: 600,
          },
          on: {
            ok: _vm.triggerPanelOrAudit,
            cancel: function ($event) {
              _vm.showAuditAndSave = false
            },
          },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.canOperate } },
            [
              _c("a-textarea", {
                attrs: { placeholder: "审批意见", maxLength: 50 },
                model: {
                  value: _vm.enableSaveAndAudit,
                  callback: function ($$v) {
                    _vm.enableSaveAndAudit = $$v
                  },
                  expression: "enableSaveAndAudit",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "查看审批记录",
            centered: "",
            visible: _vm.showHistory,
            footer: null,
            width: 800,
          },
          on: {
            cancel: function ($event) {
              _vm.showHistory = false
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "700px",
                height: "200px",
                background: "#fff",
                margin: "0 auto",
              },
            },
            [
              _c("img", {
                staticStyle: {
                  width: "100%",
                  height: "100%",
                  "object-fit": "contain",
                },
                attrs: { src: _vm.recordImg, alt: "" },
              }),
            ]
          ),
          _c(
            "vxe-grid",
            _vm._b(
              {
                ref: "xGrid",
                staticClass: "column-sortable-grid",
                attrs: {
                  "column-key": "",
                  data: _vm.list,
                  "auto-resize": true,
                },
              },
              "vxe-grid",
              _vm.gridOptions,
              false
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }